(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function setModeClass() {
    if (isMobile()) document.body.classList.add('sidebar-accordion-on');
    else document.body.classList.remove('sidebar-accordion-on');
  }

  function closeAllExcept(exceptLi) {
    document
      .querySelectorAll('nav.primary-menu li.has-submenu.open-submenu')
      .forEach(function (openLi) {
        if (openLi !== exceptLi) {
          openLi.classList.remove('open-submenu');
          var openSub = openLi.querySelector(':scope > .sidebar__submenu');
          if (openSub) openSub.setAttribute('aria-expanded', 'false');
        }
      });
  }

  function initSidebarAccordion() {
    setModeClass();
    if (!isMobile()) return;

    var parentLinks = document.querySelectorAll(
      'nav.primary-menu li.has-submenu > a.parent-has-submenu'
    );

    parentLinks.forEach(function (a) {
      if (a.dataset.accordionBound === '1') return;
      a.dataset.accordionBound = '1';

      a.addEventListener(
        'click',
        function (e) {
          var li = a.closest('li.has-submenu');
          if (!li) return;

          var submenu = li.querySelector(':scope > .sidebar__submenu');
          if (!submenu) return;

          // всегда в режиме accordion
          document.body.classList.add('sidebar-accordion-on');

          e.preventDefault();
          e.stopPropagation();

          var willOpen = !li.classList.contains('open-submenu');

          // один открыт
          closeAllExcept(li);

          li.classList.toggle('open-submenu', willOpen);
          submenu.setAttribute('aria-expanded', String(willOpen));
        },
        true
      );
    });
  }

  document.addEventListener('DOMContentLoaded', initSidebarAccordion);
  document.addEventListener('shopify:section:load', initSidebarAccordion);

  // если меню рисуется/меняется после открытия
  document.addEventListener('click', function () {
    initSidebarAccordion();
  });

  // на ресайз (поворот/изменение ширины)
  window.addEventListener('resize', function () {
    setModeClass();
  });
})();
